
    import { defineComponent, onBeforeMount } from 'vue'

    import SimplePage from '@/app/components/SimplePage.vue'

    import { useBreadcrumbsStore } from '@/app/stores/breadcrumbs'

    export default defineComponent({
        components: {
            SimplePage
        },
        props: {
            page: {
                type: String,
                required: true
            }
        },
        setup () {
            onBeforeMount(() => useBreadcrumbsStore().reset())

            return {}
        }
    })
